import { render, staticRenderFns } from "./AddProductProperty.vue?vue&type=template&id=38b607c0&"
import script from "./AddProductProperty.vue?vue&type=script&lang=js&"
export * from "./AddProductProperty.vue?vue&type=script&lang=js&"
import style0 from "./AddProductProperty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports